import type { RTEPackDefs, RTETreeDefs } from "../RichTextEditorProps";

const VALID_NODE_TYPES: ReadonlySet<string> = new Set(["code", "heading", "linebreak", "link", "list", "listitem", "paragraph", "text"]);

const hasNodeObj = ({ type }: Pick<RTETreeDefs[number], "type">): boolean => {
  return !!type && typeof type === "string" && VALID_NODE_TYPES.has(type);
};

const isNodeList = ({ nodes }: Pick<RTEPackDefs, "nodes">): boolean => {
  return !!nodes && Array.isArray(nodes) && nodes.every(hasNodeObj);
};

const hasVersion = ({ version }: Pick<RTEPackDefs, "version">): boolean => {
  if (typeof version === "number") return version > 0;
  return typeof version === "string" && version.trim().length > 0;
};

const isComponentsEnvelope = (meta?: RTEPackDefs): boolean => {
  if (meta == null || typeof meta !== "object") return false;
  const { nodes, version } = meta ?? {};
  return hasVersion({ version }) && isNodeList({ nodes });
};

export const parseComponentsEnvelope = (component: string): RTEPackDefs | null => {
  try {
    const module: RTEPackDefs = JSON.parse(component);
    if (isComponentsEnvelope(module)) return module;
    else throw new Error("Parsed value is not a valid components envelope");
  } catch (error) {
    console.error("Invalid components envelope JSON", { length: component.length, error });
    return null;
  }
};
